import "../../styles/Requests.css";
import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import {useCookies} from "react-cookie";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import {Navigate, useNavigate} from "react-router-dom";

export default function Requests({ dark, setDark, sidebarOpen, setSidebarOpen }) {
    const navigate = useNavigate();
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showLogsTorrent, setShowLogsTorrent] = useState(false);
    const [torrent, setTorrent] = useState([]);
    const [torrentName, setTorrentName] = useState("");
    const [torrentLoading, setTorrentLoading] = useState(false);
    const [torrentPage, setTorrentPage] = useState(1);
    const [torrentTotal, setTorrentTotal] = useState(0);

    // Chart
    const months = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    // Table
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12; // nombre d’éléments par page
    const [deleteConfirm, setDeleteConfirm] = useState(null);
    const [closingConfirm, setClosingConfirm] = useState(false);

    //Drawer
    const [openAddDrawer, setOpenAddDrawer] = useState(false);
    const [closingDrawer, setClosingDrawer] = useState(false);
    const [openEditDrawer, setOpenEditDrawer] = useState(false);
    const [editRequest, setEditRequest] = useState(null);

    //Toast
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [toastProgress, setToastProgress] = useState(100);

    const [newRequest, setNewRequest] = useState({
        title: "",
        user: "3",
        followmaj: "0"
    });



    const [cookies, setCookie, removeCookie] = useCookies(['user']);

    const toggleTheme = () => setDark(!dark);

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    const [user, setUser] = useState(null);
    
    const isAdminOrModerator = (role) => {
        return role === "Admin" || role === "Moderateur";
    };
    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);



    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const res = await fetch("https://api.industriegaming.fr/api/script/request/getall", {
                headers: {
                    "Authorization": `Bearer ${cookies.token}`,
                }
            });
            if (res.status === 401) {
                removeCookie("token", { path: "/" });
                navigate("/");
                return null;
            }
            const data = await res.json();
            setRequests(data);
        } catch (err) {
            console.error("Erreur :", err);
        } finally {
            setLoading(false);
        }
    };

    const totalPages = Math.ceil(requests.length / itemsPerPage);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentRequests = requests.slice(indexOfFirstItem, indexOfLastItem);

    const getPaginationButtons = () => {
        const pages = [];

        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 4) {
                pages.push(1, 2, 3, 4, 5, "...", totalPages);
            } else if (currentPage >= totalPages - 3) {
                pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
            }
        }

        return pages;
    };

    const showSuccess = (msg) => {
        setSuccessMessage(msg);
        setToastProgress(100);

        let width = 100;
        const interval = setInterval(() => {
            width -= 1;
            setToastProgress(width);

            if (width <= 0) {
                clearInterval(interval);
                setSuccessMessage("");
            }
        }, 30); // 100 * 30ms = 3 secondes

        // setTimeout(() => setSuccessMessage(""), 3000);
    };

    const showError = (msg) => {
        setErrorMessage(msg);
        setToastProgress(100);

        let width = 100;
        const interval = setInterval(() => {
            width -= 1;
            setToastProgress(width);

            if (width <= 0) {
                clearInterval(interval);
                setErrorMessage("");
            }
        }, 30);

        // setTimeout(() => setErrorMessage(""), 3000);
    };

    const reworkRequest = async (id) => {
        // if (user?.role !== "Admin") return;
        const res = await fetch(`https://api.industriegaming.fr/api/script/request/rework/${id}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${cookies.token}`
            }
        });

        if (!res.ok) {
            showError("Impossible de complété la demande");
            return;
        }

        fetchRequests();
        showSuccess("Votre request est de retour !");
    };

    const openConfirm = (id) => {
        if (user?.role !== "Admin") return;
        setClosingConfirm(false);
        setDeleteConfirm(id);
    };

    const closeConfirm = () => {
        setClosingConfirm(true);
        setTimeout(() => {
            setDeleteConfirm(null);
            setClosingConfirm(false);
        }, 300); // durée de l’animation
    };

    const deleteRequest = async () => {
        try {
            const res = await fetch(`https://api.industriegaming.fr/api/script/request/delete/${deleteConfirm}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${cookies.token}`
                }
            });

            if (!res.ok) {
                showError("Impossible de complété la demande");
                return;
            }

            fetchRequests();
            showSuccess("Demande complétée avec succès !");
        } catch (err) {
            showError("Une erreur est survenue");
        }
    };

    const getSiteColor = (site) => {
        if (!site) return "badge-default";

        const s = site.toLowerCase();

        if (s.includes("skidrow")) return "badge-blue";
        if (s.includes("c411") || s.includes("ygg")) return "badge-purple";

        return "badge-default";
    };




    const chartData = months.map((m, i) => ({
        month: m,
        count: requests.filter(req => {
            if (!req.created_at) return false;
            const date = new Date(req.created_at);
            return date.getFullYear() === selectedYear && date.getMonth() === i;
        }).length
    }));

    const openDrawer = () => {
        if (!isAdminOrModerator(user?.role)) return;
        setClosingDrawer(false);
        setOpenAddDrawer(true);
    };

    const openEdit = (req) => {
        if (user?.role !== "Admin") return;
        setEditRequest(req);
        setClosingDrawer(false);
        setOpenEditDrawer(true);
    };

    const closeDrawer = () => {
        setClosingDrawer(true);
        setTimeout(() => {
            setOpenAddDrawer(false);
            setClosingDrawer(false);
        }, 300); // durée de l’animation
    };



    const addRequest = async (req) => {

        if (!req.user.trim() || !req.title.trim()) {
            showError("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        try {
            const res = await fetch("https://api.industriegaming.fr/api/script/request/create", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`
                },
                body: JSON.stringify(req)
            });

            if (!res.ok) {
                showError("Erreur lors de la création de la demande");
            }

            // req.title = req.title.replace(/-|\s/g,",")
            //
            // // --- Ajout dans la table locale ---
            // setRequests([...requests, {
            //     id: Date.now(),
            //     ...req
            // }]);
            fetchRequests();
            showSuccess("Demande ajoutée avec succès !");
        } catch (err) {
            showError("Une erreur est survenue");
        }
    };

    const updateRequest = async () => {
        if (!editRequest) return;
        if (!editRequest.title.trim() || !editRequest.user.trim()) {
            showError("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        try {
            const res = await fetch(`https://api.industriegaming.fr/api/script/request/edit/${editRequest.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cookies.token}`
                },
                body: JSON.stringify({ title: editRequest.title, user: editRequest.user })
            });

            if (!res.ok) {
                showError("Impossible de mettre à jour la demande.");
                return;
            }

            // mettre à jour localement
            setRequests(requests.map(r => r.id === editRequest.id ? editRequest : r));
            setOpenEditDrawer(false);
            showSuccess("Demande mise à jour !");
            fetchRequests();
        } catch (err) {
            showError("Une erreur est survenue");
        }
    };

    const formatUser = (value) => {
        if (value === "3") return "Tout le monde";
        if (value === "195249015858790400") return "Phil";
        if (value === "723421020471427122") return "Strass";
        return value;
    };


    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />

                <div className="users-page">

                    {/* HEADER IDENTIQUE À USERS */}
                    <div className="users-header">
                        <div className="users-header-logo">
                            <h1>Demandes</h1>
                        </div>
                        {(user?.role === "Admin" || user?.role === "Moderateur") && (
                            <button className="add-user-btn" onClick={openDrawer}>
                                + Ajouter une demande
                            </button>
                        )}
                    </div>

                    {/* WRAPPER IDENTIQUE */}
                    <div className="users-table-wrapper">
                        <table className="users-table">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Jeux</th>
                                <th>Utilisateur</th>
                                <th>MAJ</th>
                                <th>Date</th>
                                <th>Complétion</th>
                                <th>Trouvé</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {currentRequests.map((req) => (
                                <tr key={req.id} className={req.datecompletion ? 'requested-row' : ''}>
                                    <td>{req.id}</td>
                                    <td>{req.title}</td>
                                    <td>{formatUser(req.user)}</td>
                                    <td className="center-col">
                                        <span className={`followmaj ${req.followmaj ? 'true' : 'false'}`}
                                              title={req.followmaj ? 'Suivi activé' : 'Suivi désactivé'}
                                              aria-label={req.followmaj ? 'Suivi activé' : 'Suivi désactivé'}>
                                                {req.followmaj ? '✓' : '✕'}
                                        </span>
                                    </td>
                                    <td>
                                        {req.created_at ? (
                                            <>
                                                {new Date(req.created_at).toLocaleDateString("fr-FR")} {" - "}
                                                {new Date(req.created_at).toLocaleTimeString("fr-FR", {
                                                    hour: "2-digit",
                                                    minute: "2-digit"
                                                })}
                                            </>
                                        ) : (
                                            <span style={{opacity: 0.6}}>—</span>
                                        )}
                                    </td>
                                    <td>
                                        {req.datecompletion ? (
                                            <>
                                                {new Date(req.datecompletion).toLocaleDateString("fr-FR")} {" - "}
                                                {new Date(req.datecompletion).toLocaleTimeString("fr-FR", {
                                                    hour: "2-digit",
                                                    minute: "2-digit"
                                                })}
                                            </>
                                        ) : (
                                            <span style={{opacity: 0.6}}>—</span>
                                        )}
                                    </td>
                                    <td>
                                        {
                                            req.counterlink === "0" ? (
                                                <p>0</p>
                                            ) : (
                                                <div className="seeyou">
                                                <p>{req.counterlink}</p>
                                                    <button className="logs-btn" onClick={async () => {
                                                        setShowLogsTorrent(true);
                                                        setTorrent(req.torrentlink);
                                                        setTorrentLoading(true);
                                                        try {
                                                            const res = await fetch(`https://api.industriegaming.fr/api/script/request/getlink/${req.torrentlink}`, {headers: {Authorization: `Bearer ${cookies.token}`}});
                                                            const data = await res.json();
                                                            setTorrent(data || []);
                                                            const torrentNameNew = req.title.replace(/,/g, " ");
                                                            setTorrentName(torrentNameNew)
                                                            setTorrentPage(1);
                                                            setTorrentTotal(data.total || 0);
                                                        } catch (e) {
                                                            console.error(e);
                                                        }
                                                        setTorrentLoading(false);
                                                    }} title="Voir les torrents trouvés">
                                                        👁️
                                                    </button>
                                                </div>
                                            )
                                        }
                                    </td>
                                    <td className="actions">
                                        {user?.role === "Admin" && (
                                            <>
                                                {req.datecompletion ? (
                                                    <>
                                                        <button className="return-btn" onClick={() => reworkRequest(req.id)}>
                                                            ♻️
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <button className="edit-btn" onClick={() => openEdit(req)}>
                                                            ✏️
                                                        </button>
                                                        <button
                                                            className="delete-btn"
                                                            onClick={() => openConfirm(req.id)}
                                                        >
                                                        ❌
                                                        </button>
                                                    </>
                                            )}
                                    </>
                                    )}
                                </td>
                                </tr>
                                ))}

                            {/* Lignes vides pour garder la hauteur comme Users */}
                            {Array.from({length: itemsPerPage - currentRequests.length}).map((_, i) => (
                                <tr key={`empty-${i}`} className="empty-row">
                                    <td colSpan="5"></td>
                                </tr>
                            ))}
                            </tbody>

                        </table>
                        <div className="pagination">
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>

                            {getPaginationButtons().map((page, index) =>
                                page === "..." ? (
                                    <span key={index} className="dots">...</span>
                                ) : (
                                    <button
                                        key={index}
                                        className={currentPage === page ? "active" : ""}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                    </button>
                                )
                            )}

                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                <i className="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>

                    </div>
                    {/* BLOC GRAPHIQUE */}
                    <div className="users-table-wrapper request-chart-wrapper">
                        <div className="chart-header">
                            <h2 className="chart-title">Demandes par mois</h2>

                            <select
                                className="year-dropdown"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(Number(e.target.value))}
                            >
                                {Array.from({length: 5}).map((_, i) => {
                                    const year = new Date().getFullYear() - i;
                                    return <option key={year} value={year}>{year}</option>;
                                })}
                            </select>
                        </div>

                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={chartData}>
                                <XAxis dataKey="month" stroke={dark ? "#ffffff" : "#000000"}/>
                                <YAxis stroke={dark ? "#ffffff" : "#000000"}/>
                                <Tooltip
                                    cursor={{ fill: "transparent" }}
                                    contentStyle={{
                                        background: "var(--card-bg)",
                                        border: "1px solid var(--border-color)",
                                        color: dark ? "#ffffff" : "#000000"
                                    }}
                                    formatter={(value) => [`${value} demandes`]}
                                    labelFormatter={(label) => `Mois : ${label}`}
                                />
                                <Bar dataKey="count" fill={dark ? "#598580" : "#98e3da"} radius={[6, 6, 0, 0]}/>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>


                </div>
            </div>
            {openAddDrawer && (
                <div
                    className={`drawer-overlay ${closingDrawer ? "closing" : ""}`}
                    onClick={closeDrawer}
                >
                    <div
                        className={`drawer ${closingDrawer ? "closing" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2>Ajouter une demande</h2>

                        <label>Titre</label>
                        <input
                            type="text"
                            value={newRequest.title}
                            onChange={(e) =>
                                setNewRequest({...newRequest, title: e.target.value})
                            }
                        />

                        <label>User</label>
                        {/*<input*/}
                        {/*    type="text"*/}
                        {/*    value={newRequest.user}*/}
                        {/*    onChange={(e) =>*/}
                        {/*        setNewRequest({ ...newRequest, user: e.target.value })*/}
                        {/*    }*/}
                        {/*/>*/}
                        <select
                            value={newRequest.user || "3"}
                            onChange={(e) =>
                                setNewRequest({...newRequest, user: e.target.value})
                            }
                        >
                            <option value="3">Tout le monde</option>
                            <option value="195249015858790400">Phil</option>
                            <option value="723421020471427122">Strass</option>
                        </select>

                        <label>Suivi MAJ</label>
                        <select
                            value={newRequest.followmaj || "0"}
                            onChange={(e) => setNewRequest({...newRequest, followmaj: e.target.value})}
                        >
                            <option value="0">Non</option>
                            <option value="1">Oui</option>
                        </select>

                        <button
                            className="save-user-btn"
                            onClick={async () => {
                                await addRequest(newRequest);
                                setNewRequest({title: "", user: "", followmaj: "0"});
                                closeDrawer();
                            }}
                        >
                            Ajouter la demande
                        </button>
                    </div>
                </div>
            )}
            {deleteConfirm && (
                <div className="confirm-overlay" onClick={closeConfirm}>
                    <div
                        className={`confirm-box ${closingConfirm ? "closing" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3>Complété cette demande ?</h3>
                        <p>Vous pourez toujours remettre cette demande en liste.</p>

                        <div className="confirm-actions">
                            <button className="cancel-btn" onClick={closeConfirm}>
                                Annuler
                            </button>

                            <button
                                className="delete-btn2"
                                onClick={async () => {
                                    await deleteRequest();
                                    closeConfirm();
                                }}
                            >
                                Complété
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {openEditDrawer && editRequest && (
                <div
                    className={`drawer-overlay ${closingDrawer ? "closing" : ""}`}
                    onClick={() => { setOpenEditDrawer(false); setClosingDrawer(false); }}
                >
                    <div
                        className={`drawer ${closingDrawer ? "closing" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2>Modifier la demande</h2>

                        <label>Titre</label>
                        <input
                            type="text"
                            value={editRequest.title}
                            onChange={(e) => setEditRequest({...editRequest, title: e.target.value})}
                        />

                        <label>User</label>
                        <select
                            value={editRequest.user}
                            onChange={(e) => setEditRequest({...editRequest, user: e.target.value})}
                        >
                            <option value="3">Tout le monde</option>
                            <option value="195249015858790400">Phil</option>
                            <option value="723421020471427122">Strass</option>
                        </select>

                        <label>Suivi MAJ</label>
                        <select
                            value={editRequest.followmaj}
                            onChange={(e) => setEditRequest({...editRequest, followmaj: e.target.value})}
                        >
                            <option value="0">Non</option>
                            <option value="1">Oui</option>
                        </select>

                        <button className="save-user-btn" onClick={async () => { await updateRequest(); setOpenEditDrawer(false); }}>
                            Enregistrer les modifications
                        </button>
                    </div>
                </div>
            )}
            {successMessage && (
                <div className="toast-success">
                    {successMessage}
                    <div className="toast-progress" style={{width: `${toastProgress}%`}}></div>
                </div>
            )}

            {errorMessage && (
                <div className="toast-error">
                    {errorMessage}
                    <div className="toast-progress" style={{width: `${toastProgress}%`}}></div>
                </div>
            )}

            {showLogsTorrent && (
                <div className="logs-modal-overlay" onClick={() => setShowLogsTorrent(false)}>
                    <div className="logs-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="logs-modal-header">
                            <h3>Torrent trouvé pour {torrentName}</h3>
                            <button className="close-modal" onClick={() => setShowLogsTorrent(false)}>&times;</button>
                        </div>
                        <div className="logs-modal-body">
                            {torrentLoading ? <div>Chargement...</div> : (
                                <table className="logs-table">
                                    <thead>
                                    <tr>
                                        <th>Titre</th>
                                        <th>Site</th>
                                        <th>Date</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {torrent.map(l => (
                                            <tr key={l.id}>
                                                <td style={{
                                                    maxWidth: 500,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>

                                                    <a href={l.lien}
                                                       target="_blank" rel="noopener noreferrer"
                                                       className="torrent-link">
                                                        {l.title}
                                                    </a>
                                                </td>
                                                <td>
                                                    <span className={`site-badge ${getSiteColor(l.web)}`}>
                                                        {l.web}
                                                    </span>
                                                </td>
                                                <td>
                                                    {new Date(l.created_at).toLocaleDateString("fr-FR")} {" - "}
                                                    {new Date(l.created_at).toLocaleTimeString("fr-FR", {
                                                        hour: "2-digit",
                                                        minute: "2-digit"
                                                    })}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <div className="logs-modal-footer">
                            {torrent.length < torrentTotal && (
                                <button className="load-more" onClick={async () => {
                                    const next = torrentPage + 1;
                                    setTorrentLoading(true);
                                    try {
                                        // const res = await fetch(`https://api.industriegaming.fr/api/auth/users/${id}/logs?limit=200&page=${next}`, { headers: { Authorization: `Bearer ${cookies.token}` } });
                                        // const data = await res.json();
                                        const data = "" // Remplacez cette ligne par la vraie requête pour récupérer les torrents
                                        setTorrent(prev => prev.concat(data.logs || []));
                                        setTorrentPage(next);
                                    } catch (e) { console.error(e); }
                                    setTorrentLoading(false);
                                }}>Charger plus</button>
                            )}
                        </div>
                    </div>
                </div>
            )}

        </div>
    );

}
